import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

/**
 * Click a thumbnail to preview the full-size image in a modal, instead of
 * navigating to the raw file URL in a new tab (which can trip up admin
 * sessions on some browsers). The thumbnail <img> already loads fine via
 * cookie-authenticated GET, so the same src is reused for the full view.
 */
export function ImagePreviewDialog({ src, alt, className, testId }) {
  const [open, setOpen] = useState(false);
  if (!src) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={testId} className="block">
        <img src={src} alt={alt} className={className} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl p-2" data-testid={`${testId}-modal`}>
          <DialogTitle className="sr-only">{alt}</DialogTitle>
          <img src={src} alt={alt} className="w-full max-h-[80vh] object-contain rounded-md" />
        </DialogContent>
      </Dialog>
    </>
  );
}
